const routers = [

    {
        path: '/statistics/workLoad',
        name: 'WorkLoad',
        component: resolve => require(['../views/statistics/WorkLoad'], resolve)
    },
    {
        path: '/statistics/strategyExe',
        name: 'StrategyExe',
        component: resolve => require(['../views/statistics/StrategyExe'], resolve)
    },
    {
      path: '/statistics/application',
      name: 'ApplicationExe',
      component: resolve => require(['../views/statistics/ApplicationExe'], resolve)
    }

];
export default routers;



// WEBPACK FOOTER //
// ./src/routers/statistics.js